<div class="flex flex-row w-full gap-1 items-stretch">
    <div *ngFor="let option of scales.options" class="flex flex-row items-center justify-center"
        [style.width.%]="100/scales?.options?.length">
        <div [ngClass]="question.answer == option.key?'border-exp text-exp border-2':'border-transparent text-zen text-opacity-90'"
            (click)="questionAnswer(option.key)"
            class="flex flex-col items-center justify-start py-3 w-full btn  bg-white border border-inset rounded gap-2 md:gap-2 h-full">
            <i [style.color]="option.color"
                [ngClass]="question.answer == option.key && option.iconSelected?option.iconSelected:option.icon"
                class="text-2xl md:text-4xl leading-10 md:leading-12 rounded-lg w-full text-center"></i>
            <h5 class=" text-opacity-80 text-xxs md:text-sm font-medium  text-center"> {{
                getConfidence('single-answer-rating', option.key)}}</h5>
        </div>
    </div>
</div>